// 官网提示说明（非表单）
export default {
  直播中: 'Live Now',
  看回放: 'Replay',
  直播状态: 'Status',
  直播频道: 'Channel',
  暂无相关直播: 'No relevant live stream yet.',
  直播不存在: 'Live stream doesn’t exist.',
  已下架: 'Removed',
  直播公告: 'Description',
  直播已结束: 'Live stream ended.',
  直播已禁播: 'Live stream banned.',
  违规原因: 'Reasons of Violation',
  推荐更多精彩直播: 'More Live Streams Recommended for You',
  Ta的直播产品: 'His/Her Live Stream Products',
  相似直播推荐: 'Similar Live Streams Recommended for You',
  预告: 'Upcoming Live Stream',
  开播时间: 'Start Time',
  收费价格: 'Price (Coin)',
  观看是否收费: 'Free or Paid',
  直播展览: 'Exhibition Live Streams',
  直播会议: 'Conference Live Stream',
  付费: 'Paid',
  免费: 'Free',
  直播产品: 'Live Products',
  立即下单: 'Place Order Now',
  正在直播推荐: 'Recommended for You',
  直播推荐: 'Live Streams Recommended for You',
  全部评论: 'All Comments',
  欢迎来到直播间提示:
    'Welcome! Cloud Exhibition strives to build a healthy live streaming platform for its users. Accounts will be suspended permanently if found live streaming contents that violate our policies, such as pornography, vulgarity, smoking, alcohol abuse, or other illegal activities.',
  回车Enter发送: 'Send',
  发送评论每次最多30个字符: 'Each comment is limited to 60 characters.',
  您未登录请登录后在发言: 'Please log in to post a comment.',
  直播服务购买: 'Purchase Live Stream Service',
  总费用: 'Grand Total',
  聊一聊: 'Chat',
  前往详情: 'Go to Details',
}
